import React, { useState, useRef, useMemo, useEffect } from "react";
import { ENTORNO } from "../../utils/constantes";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Alert from "@mui/material/Alert";
import "../../scss/index.scss";
import {
  selecciona_punto_de_partida,
  selecciona_punto_destino,
  no_se_encontro_ninguna_direccion,
  buscar_calle,
} from "../../utils/traductor";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import * as L from "leaflet";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import { Form, Segment, Divider, Input, List } from "semantic-ui-react";
import { apiGeolocalizacion } from "../../api/geolocalizacion";

const apigeolocalizacion = new apiGeolocalizacion();

export function PartidaDestino({
  Modo,
  Latitud,
  setLatitud,
  Longitud,
  setLongitud,
  Localidad,
  setLocalidad,
  Provincia,
  setProvincia,
  Pais,
  setPais,
  LatitudGps,
  setLatitudGps,
  LongitudGps,
  setLongitudGps,
  LatitudIp,
  setLatitudIp,
  LongitudIp,
  setLongitudIp,
  Ubicacion,
  setUbicacion,
}) {
  const [GeoLocalizacionCalculado, setGeoLocalizacionCalculado] =
    useState(false);
  const [IPPublica, setIPPublica] = useState("");
  const [LocalidadCalculada, setLocalidadCalculada] = useState("");
  const [ProvinciaCalculada, setProvinciaCalculada] = useState("");
  const [PaisCalculado, setPaisCalculado] = useState("");
  const [LatLonIP, setLatLonIP] = useState("");
  const [LatIP, setLatIP] = useState("");
  const [LonIP, setLonIP] = useState("");
  const [LatLonGPS, setLatLonGPS] = useState("");
  const [LatGPS, setLatGPS] = useState("");
  const [LonGPS, setLonGPS] = useState("");

  const [DireccionCalculada, setDireccionCalculada] = useState("");
  const [Lat, setLat] = useState("");
  const [Lon, setLon] = useState("");

  const [map, setMap] = useState(null); // The map instance

  let DireccionesAux = [];
  const [Direcciones, setDirecciones] = useState([]);
  const [ListaResultadosVisible, setListaResultadosVisible] = useState();
  const [PartidaValor, setPartidaValor] = useState("");
  const [LatLonManual, setLatLonManual] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        if (GeoLocalizacionCalculado === false) {
          //calculo ip publica
          const ipPublica = require("react-public-ip");
          const ipv4 = (await ipPublica.v4()) || "";
          setIPPublica(ipv4);

          ///////////////////////////////////////////////////////

          //calculo localidad y lat lon con ip publica
          const parametros = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          };

          const respuesta = await fetch(
            ENTORNO.Ping_IPtoLatLon1.replace("ipPublica", ipv4),
            parametros
          );

          const respuestaJson = await respuesta.json();

          //regla de negocio para casos particulares: cordoba --> cordoba capital
          let city = respuestaJson.city;
          if (respuestaJson.city === "Córdoba") {
            city = "Córdoba Capital";
          }

          setLocalidadCalculada(city);
          setProvinciaCalculada(respuestaJson.region);
          setPaisCalculado(respuestaJson.country);
          setLatLonIP(respuestaJson.loc);
          setLatIP(respuestaJson.loc.split(",")[0]);
          setLonIP(respuestaJson.loc.split(",")[1]);
          setLocalidad(respuestaJson.city);
          setProvincia(respuestaJson.region);
          setPais(
            respuestaJson.country === "ES"
              ? "España"
              : PaisCalculado === "AR"
              ? "Argentina"
              : ""
          );
          setLatitudIp(respuestaJson.loc.split(",")[0]);
          setLongitudIp(respuestaJson.loc.split(",")[1]);

          setLat(respuestaJson.loc.split(",")[0]);
          setLon(respuestaJson.loc.split(",")[1]);

          setLatitud(respuestaJson.loc.split(",")[0]);
          setLongitud(respuestaJson.loc.split(",")[1]);

          ///////////////////////////////////////////////////////

          //calculo lat lon con GPS
          const onUbicacionConcedida = (ubicacion) => {
            setLatLonGPS(
              ubicacion.coords.latitude + ", " + ubicacion.coords.longitude
            );

            setLatGPS(ubicacion.coords.latitude);
            setLonGPS(ubicacion.coords.longitude);

            setLatitudGps(ubicacion.coords.latitude);
            setLongitudGps(ubicacion.coords.longitude);

            setLat(ubicacion.coords.latitude);
            setLon(ubicacion.coords.longitude);

            setLatitud(ubicacion.coords.latitude);
            setLongitud(ubicacion.coords.longitude);

            calcularReverse(
              ubicacion.coords.latitude,
              ubicacion.coords.longitude
            );
          };

          const onErrorDeUbicacion = (err) => {
            setLatLonGPS("");
            setLatGPS("");
            setLonGPS("");

            setLatitudGps("");
            setLongitudGps("");

            setLat("");
            setLon("");

            setLatitud("");
            setLongitud("");
          };

          const opcionesDeSolicitud = {
            enableHighAccuracy: true, // Alta precisión
            maximumAge: 0, // No queremos caché
            timeout: 5000, // Esperar solo 5 segundos
          };

          // Solicitar
          navigator.geolocation.getCurrentPosition(
            onUbicacionConcedida,
            onErrorDeUbicacion,
            opcionesDeSolicitud
          );

          setGeoLocalizacionCalculado(true);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  //////////////////////////////////////////////////////

  const markerRefMarker = useRef(null);
  const eventHandlersMarker = useMemo(
    () => ({
      dragend() {
        const marker = markerRefMarker.current;
        if (marker != null) {
          setLat(marker.getLatLng().lat);
          setLon(marker.getLatLng().lng);

          setLatitud(marker.getLatLng().lat);
          setLongitud(marker.getLatLng().lng);

          calcularReverse(marker.getLatLng().lat, marker.getLatLng().lng);
        }
      },
    }),
    []
  );

  ////////////////////////////////////////////////////////

  // Create the routing-machine instance:
  //Centrar el mapa
  useEffect(() => {
    if (!map) return;

    if (map) {
      map.panTo(new L.LatLng(Lat, Lon));
    }
  });

  ////////////////////////////////////////////////////////

  //calcular reverse
  const calcularReverse = async (Lat, Lon) => {
    try {
      const resultado = await apigeolocalizacion.LatLonToDireccionPostal(
        Lat,
        Lon
      );

      setDireccionCalculada(resultado.Direccion);
      setUbicacion(resultado.Direccion);
    } catch (error) {
      console.error(error);
    }
  };

  ////////////////////////////////////////////////////////

  //autocomplete
  const autocomplete = async (
    DireccionABuscar,
    localidad,
    provincia,
    pais,
    Numeracion
  ) => {
    try {
      DireccionesAux = await apigeolocalizacion.autocomplete(
        DireccionABuscar,
        localidad,
        provincia,
        pais,
        Numeracion
      );

      setDirecciones(DireccionesAux);
    } catch (error) {
      console.error(error);
    }
  };
  ////////////////////////////////////////////////////////

  return (
    <Card style={{ boxShadow: "none", borderRadius: "10px" }}>
      <Alert severity="info">
        {Modo === "Partida"
          ? selecciona_punto_de_partida
          : selecciona_punto_destino}
      </Alert>
      <CardContent>
        <Form.Field>
          <Input
            id="BuscadorDeCalles"
            name="BuscadorDeCalles"
            placeholder={buscar_calle}
            value={PartidaValor}
            onKeyDown={(e) => {
              e.key === "Enter" && e.preventDefault();
            }}
            onFocus={(e) => e.target.select()}
            onChange={(e, data) => {
              setDirecciones(
                Direcciones.filter((a) => a.type !== Direcciones.type)
              );

              setListaResultadosVisible(false);

              let DireccionABuscar = e.target.value;

              setPartidaValor(e.target.value);

              //calcular Numero
              let Numeracion = "";
              let i = 0;

              let PalabrasArreglo = DireccionABuscar.split(" ");
              for (i = 0; i < PalabrasArreglo.length; i++) {
                if (isNaN(parseInt(PalabrasArreglo[i])) === false) {
                  Numeracion = PalabrasArreglo[i];
                }
              }
              /////////////////

              if (DireccionABuscar.length > 4) {
                setListaResultadosVisible(true);

                let localidad = ", " + LocalidadCalculada;
                let provincia = ", " + ProvinciaCalculada;
                let pais =
                  ", " +
                  (PaisCalculado === "ES"
                    ? "España"
                    : PaisCalculado === "AR"
                    ? "Argentina"
                    : "");

                // localidad = ", Ushuaia";
                // provincia = ", Tierra del Fuego Province";
                // pais = ", Argentina";

                // localidad = ", Cordoba";
                // provincia = ", Cordoba";
                // pais = ", Argentina";

                autocomplete(
                  DireccionABuscar,
                  localidad,
                  provincia,
                  pais,
                  Numeracion
                );
              }
            }}
          />
          {ListaResultadosVisible === true ? (
            <List
              className="search-lista-resultados"
              divided
              relaxed
              style={{
                zIndex: "1",
              }}
            >
              {Direcciones.map((fila) => {
                return (
                  <List.Content key={fila.key}>
                    <List.Header>
                      <b>
                        <label
                          as="a"
                          onClick={() => {
                            setLat(fila.key.split("|")[0]);
                            setLon(fila.key.split("|")[1]);

                            setLatitud(fila.key.split("|")[0]);
                            setLongitud(fila.key.split("|")[1]);

                            setListaResultadosVisible(false);
                            setLatLonManual(true);

                            calcularReverse(
                              fila.key.split("|")[0],
                              fila.key.split("|")[1]
                            );
                          }}
                        >
                          {fila.text}
                        </label>
                      </b>
                    </List.Header>
                    <List.Description>
                      <small>
                        <label
                          as="a"
                          onClick={() => {
                            setLat(fila.key.split("|")[0]);
                            setLon(fila.key.split("|")[1]);

                            setLatitud(fila.key.split("|")[0]);
                            setLongitud(fila.key.split("|")[1]);

                            setListaResultadosVisible(false);
                            setLatLonManual(true);

                            calcularReverse(
                              fila.key.split("|")[0],
                              fila.key.split("|")[1]
                            );
                          }}
                        >
                          {fila.value}
                        </label>
                      </small>
                      <Divider></Divider>
                    </List.Description>
                  </List.Content>
                );
              })}
            </List>
          ) : (
            <div></div>
          )}
        </Form.Field>
        <Segment style={{ borderColor: "#E7A218" }}>
          <MapContainer
            id="Mapa"
            name="Mapa"
            className="Mapa"
            doubleClickZoom={false}
            style={{
              height: "70vh",
              zIndex: "0",
              marginTop: "-16px",
              marginLeft: "-28px",
              marginRight: "-28px",
              marginBottom: "-20px",
            }}
            center={{
              lat: Lat,
              lng: Lon,
            }}
            zoom={16}
            scrollwheelzoom={false}
            whenCreated={(map) => setMap(map)}
            zoomControl={true}
          >
            <TileLayer
              attribution='&amp;copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <Marker
              draggable={true}
              eventHandlers={eventHandlersMarker}
              position={{
                lat: Lat,
                lng: Lon,
              }}
              ref={markerRefMarker}
            >
              <Popup>
                <span>{DireccionCalculada}</span>
              </Popup>
            </Marker>
          </MapContainer>
        </Segment>
        {/* <Divider></Divider>
        <div style={{ textAlign: "center" }}>
          IP pública: {IPPublica}
          <br></br>
          Localidad: {LocalidadCalculada}. Provincia: {ProvinciaCalculada}.
          Pais: {Pais}
          <br></br>
          LatLon IP: {LatLonIP}
          <br></br>
          LatLon GPS: {LatLonGPS}
          <br></br>
          <br></br>
          Dirección calculada: {DireccionCalculada}
          <br></br>
          Lat: {Lat}
          <br></br>
          Lon: {Lon}
          <br></br>
          Ubicación: {Ubicacion}
        </div> */}
      </CardContent>
    </Card>
  );
}
